import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CommonMetodService } from '../../../services/utils/commonMetod.service';
import { CommonService } from '../../../services/modules/common.service';
import { PersonalService } from '../../../services/modules/personal.service';
import { SnackBarService } from '../../../services/utils/snackBar.service';
import { CommonOptions, Requirements } from '../../../interfaces/interfaces';

export interface DialogData {
  module: 'Personal' | 'Employer';
  adminInfoId: string;
  isFromPersonal?: boolean;
  isUploadFlow?: boolean;
}

interface PersonaOption {
  Id: number;
  PersonalCompanyInfoId: number;
  Name: string;
  LastName: string;
  DocumentType: string;
  DocumentNumber: string;
  Photo: string;
}

interface EmpresaOption {
  Id: any;
  Name: string;
  DocumentType: string;
  DocumentNumber: string;
  Logo: string;
}

@Component({
  selector: 'app-dialog-solicitud-documento',
  templateUrl: './dialog-solicitud-documento.component.html',
  styleUrls: ['./dialog-solicitud-documento.component.scss']
})
export class DialogSolicitudDocumentoComponent implements OnInit {
  s3Bucket: string;

  controlDocumento = new FormControl();
  controlEmpresa = new FormControl();

  documentos: Requirements[] = [];
  documentoSelected: Requirements[] = [];
  personaSelected: PersonaOption[] = [];
  empresaSelected: EmpresaOption[] = [];
  empresas: EmpresaOption[] = [];
  cargandoDocumentos = true;
  cargandoEmpresas = true;
  buscandoPersona = false;

  files: any[] = [];
  comentario: string = '';

  documentType = 'CC';
  documentNumber = '';
  maxCaracter = 11;
  companyDocumentType: CommonOptions[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogSolicitudDocumentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public commonMetodService: CommonMetodService,
    private commonService: CommonService,
    private personalService: PersonalService,
    private snackBService: SnackBarService
  ) { }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    this.cargandoDocumentos = true;
    const requirementsRequest = this.data.module === 'Employer'
      ? this.commonService.getRequirementsCertEmployer()
      : this.commonService.getRequirementsCertPersonal();
    requirementsRequest.subscribe((requirements: Requirements[]) => {
      this.documentos = (requirements || []).filter(r => r.IsActive === true);
      this.cargandoDocumentos = false;
    });

    this.cargandoEmpresas = true;
    this.personalService.getEmployerSelect(true).subscribe((empresas: any) => {
      this.empresas = empresas || [];
      this.cargandoEmpresas = false;
      if (this.empresas.length === 1) {
        this.valueSelectedEmpresa(this.empresas[0].Id);
      }
    });

    this.commonService.getCommonOptions('CompanyDocumentType').subscribe((options: CommonOptions[]) => {
      this.companyDocumentType = (options || [])
        .filter(option => option.Value === 'CC' || option.Value === 'CE' || option.Value === 'PE' || option.Value === 'PPT')
        .sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });
  }

  changeType(value): void {
    this.maxCaracter = value === 'PE' ? 16 : value === 'CC' ? 11 : 20;
  }

  getPersonalDocument(): void {
    const cleanNumber = this.commonMetodService._replaceAll(this.documentNumber, '.', '');
    if (!cleanNumber) { return; }

    this.buscandoPersona = true;
    this.personalService.getPersonalFilterAdminInfoId(this.data.adminInfoId, 1, 5, '', cleanNumber).subscribe((rest: any) => {
      this.buscandoPersona = false;
      const encontrada = (rest?.Data || []).find(p => p.DocumentNumber === cleanNumber);
      if (encontrada) {
        this.personaSelected = [encontrada];
      } else {
        this.snackBService.openWarning('No se encontró una persona con ese número de documento en esta empresa', '', 4000);
      }
    }, () => {
      this.buscandoPersona = false;
      this.snackBService.openWarning('No se pudo realizar la búsqueda. Intente nuevamente.', '', 4000);
    });
  }

  getSubtitle(): string {
    if (this.data.isUploadFlow) {
      return 'Seleccione la empresa y el documento para iniciar la solicitud.';
    }
    return this.data.module === 'Employer'
      ? 'Seleccione el documento y la empresa para iniciar la solicitud.'
      : 'Seleccione el documento, la persona y si es requerida seleccione la empresa.';
  }

  valueSelectedDocumento(id) {
    this.documentoSelected = this.documentos.filter(doc => doc.Id === id);
    this.setValuePersona();
    this.setValueEmpresa();
  }

  setValuePersona() {
    this.personaSelected = [];
    this.documentNumber = '';
    this.documentType = this.getDefaultDocumentType();
    this.changeType(this.documentType);
    this.setValueEmpresa();
  }

  private getDefaultDocumentType(): string {
    return this.esPermisoProteccionTemporal() ? 'PPT' : 'CC';
  }

  private esPermisoProteccionTemporal(): boolean {
    if (this.data.module !== 'Personal') { return false; }
    const combiningMarks = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');
    const sinAcentos = (this.documentoSelected[0]?.Name || '').normalize('NFD').replace(combiningMarks, '');
    const nombreNormalizado = this.commonMetodService._normalizeValue(sinAcentos);
    return nombreNormalizado.includes('protecciontemporal') || nombreNormalizado.includes('pep');
  }

  valueSelectedEmpresa(id) {
    this.empresaSelected = this.empresas.filter(e => e.Id === id);
  }

  setValueEmpresa() {
    this.controlEmpresa.setValue('');
    this.empresaSelected = [];
  }

  mostrarEmpresa(): boolean {
    if (this.data.module === 'Employer') { return true; }
    if (this.documentoSelected.length !== 1) { return false; }
    return this.documentoSelected[0]?.ByEmployerPersonal === true;
  }

  puedeBuscarEmpresa(): boolean {
    if (this.data.isUploadFlow) { return true; }
    if (this.data.module === 'Employer') { return this.documentoSelected.length === 1; }
    return this.personaSelected.length === 1;
  }

  getDisabled(): boolean {
    if (this.data.isUploadFlow) {
      return this.empresaSelected.length === 1 && this.files.length > 0;
    }
    if (this.documentoSelected.length !== 1) { return false; }
    if (this.data.module === 'Personal' && this.personaSelected.length !== 1) { return false; }
    return this.mostrarEmpresa() ? this.empresaSelected.length === 1 : true;
  }

  onSelect(event: any) {
    if (this.files.length === 0) {
      this.files.push(...event.addedFiles);
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  getImgPersonal(photo): string {
    return photo || 'assets/images/personblue.png';
  }

  getImg(logo): string {
    return logo || 'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg';
  }

  iniciar() {
    if (this.data.isUploadFlow) {
      const docs: any = {
        EmployerInfoId: this.empresaSelected[0].Id,
        Files: this.files,
        Comments: this.comentario
      };
      this.dialogRef.close(docs);
      return;
    }

    const documento = this.documentoSelected[0];
    const docs: any = {
      Id: undefined,
      StateId: undefined,
      Date: null,
      RequirementId: documento.Id,
      RequirementByDate: documento.ByDate,
      ByDate: documento.ByDate,
      RequirementName: documento.Name,
      Name: documento.Name
    };

    if (this.data.module === 'Personal') {
      const persona = this.personaSelected[0];
      docs.PersonalCompanyInfoId = persona.PersonalCompanyInfoId;
      docs.PersonalName = persona.Name + ' ' + persona.LastName;
    }
    if (this.empresaSelected.length === 1) {
      docs.EmployerInfoId = this.empresaSelected[0].Id;
    }

    this.dialogRef.close(docs);
  }

}
